import React, { useState } from 'react';
import { Candidate, CandidateProfile } from './candidate-profile';
import styled from 'styled-components';

type CandidateProfileListProps = {
    candidates: Candidate[]
};

export const CandidateProfileList: React.FC<CandidateProfileListProps> = ({candidates}) => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const handleCategorySelect = (category: string) => {
    setSelectedCategory(selectedCategory === category ? null : category);
  };

  const predefinedCategories = [
    'Backend/Software',
    'Data Engineer',
    'DevOps/SRE/Cloud',
    'Engineering Manager/Director/VP',
    'Frontend/UI',
    'Full Stack',
    'Machine Learning/Data Science',
    'Mobile',
    'Product',
    'QA',
    'SecOps/Security',
    'Systems Engineer/Systems Admin',
    'Project Manager/Program Manager',
  ];

  const presentCategories = predefinedCategories.filter(category =>
    candidates.some(candidate => candidate.job_title_category.includes(category)),
  );

  const filteredCandidates = selectedCategory
    ? candidates.filter(candidate => candidate.job_title_category.includes(selectedCategory))
    : candidates;

  return (
    <div className="App">
      <div className="category-buttons">
        {presentCategories.map((category, index) => (
          <CategoryButton
            key={index}
            selected={selectedCategory === category}
            onClick={() => handleCategorySelect(category)}
          >
            {category}
          </CategoryButton>
        ))}
      </div>
      {filteredCandidates.map((candidate, index) => (
        <CandidateProfile key={index} candidate={candidate} />
      ))}
    </div>
  );
};

const CategoryButton = styled.button<{ selected: boolean }>`
  background-color: ${props => (props.selected ? '#007BFF' : '#959ba1')};
  border: none;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  margin: 4px 2px;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 4px;
  &:hover {
    background-color: ${props => (props.selected ? '#0069D9' : '#5A6268')};
  }
`;
